// import moment from 'moment-timezone';
export default {
	async getLocationDetails (city) {
		let geoData = null;
		await fetch('https://maps.googleapis.com/maps/api/geocode/json?key=' + `${process.env.VUE_APP_GOOGLEMAPAPIKEY}` + '&address=' + city)
			.then(function (response) {
				return response.json();
			}).then(function (data) {
				if (data.status === 'OK') {
					geoData = data;
				} else {
					geoData = true;
				}
			});
		return geoData;
	},
	async getTimeZone (object) {
		let timeZone = null;
		await fetch('https://api.timezonedb.com/v2.1/get-time-zone?key=B1BW364LNJZR&format=json&by=position&lat=' + object.lat + '&lng=' + object.lng)
			.then(function (response) {
				return response.json();
			}).then(function (data) {
				if (data.status === 'OK') {
					timeZone = data;
				}
			});
		return timeZone;
	},
};
